<template>
  <div class="status-change-roll-class-not-audit-final-pass">
    <el-form-item label="转入班级">
      <ClazzPicker v-model="form.targetClassId"></ClazzPicker>
    </el-form-item>
    <template v-if="auditInfo.studentInfo">
      <el-form-item v-if="form.targetClassId">
        <StudentCourseDockPanel ref="dock"
                                :student-id="auditInfo.studentInfo.id"
                                :clazz-id="form.targetClassId"></StudentCourseDockPanel>
      </el-form-item>
    </template>
    <el-form-item label="备注信息">
      <el-input v-model="form.remark"
                type="textarea"
                maxlength="200"></el-input>
    </el-form-item>
  </div>
</template>

<script>
import ClazzPicker from '../../../../../../../../../biz/picker/clazz'
import StudentCourseDockPanel from '../../../../../../wrapper/panel/student/course/dock'
export default {
  name: 'StatusChangeRollClassNotAuditFinalPass',
  components: {
    ClazzPicker,
    StudentCourseDockPanel
  },
  props: {
    applyId: {
      type: String,
      required: true
    },
    auditInfo: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      form: {
        targetClassId: '',
        remark: ''
      }
    }
  },
  methods: {
    getAuditInfo () {
      return new Promise((resolve, reject) => {
        if (!this.form.targetClassId) {
          reject(new Error('请选择转入班级'))
          return
        }
        if (!this.form.remark) {
          this.$confirm('未填写备注信息，确认继续吗?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.handleAudit(this.form, resolve, reject)
          }).catch(() => {})
        } else {
          this.handleAudit(this.form, resolve, reject)
        }
      })
    },
    handleAudit (form, resolve, reject) {
      this.$nextTick(() => {
        const dock = this.$refs.dock
        const promise = dock ? dock.getDockInfo() : Promise.resolve()
        promise.then(result => {
          resolve({
            url: '/workspace/manager/status/change/auditRollClass/final/submitPassed',
            data: this.$qs.stringify(this.$extend({
              postId: this.applyId
            }, form, result))
          })
        }).catch(err => reject(err))
      })
    }
  },
  watch: {
    auditInfo: {
      handler (val) {
        if (val) {
          Object.keys(this.form).forEach(key => {
            if (typeof this.form[key] === 'string') {
              this.form[key] = val[key] || ''
            } else {
              this.form[key] = val[key]
            }
          })
        }
      },
      immediate: true
    }
  }
}
</script>
